import { useSyncExternalStore } from 'react';
import { linkController } from '@/giraffe/linkController';
import type { LinkStatus } from '@/giraffe/linkController';

/** Subscribes to the live-link status — see giraffe/linkController.ts. */
export function useLinkStatus(): LinkStatus {
  return useSyncExternalStore(linkController.subscribe, linkController.getStatus.bind(linkController), linkController.getStatus.bind(linkController));
}
